<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login form</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Username"
                    name="username"
                    v-model="username"
                    type="text"
                    autocomplete="username"
                  />
                  <v-text-field
                    v-model="password"
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    autocomplete="password"
                    @keyup.enter="submit"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="submit">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import gql from "graphql-tag";
export default {
  apollo: {
    $client: "b"
  },
  data: function() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    submit() {
      let loginMutation = gql`
        mutation login($username: String!, $password: String!) {
          login(username: $username, password: $password) {
            success
          }
        }
      `;
      this.$apollo
        .mutate({
          mutation: loginMutation,
          variables: {
            username: this.username,
            password: this.password
          }
        })
        .then(({ data }) => {
          if (data.login && data.login.success) {
            this.$store.commit({ type: "logIn", loggedIn: true });
            this.$router.push("all-bars");
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
